import React from 'react';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';
import { amenityObject } from 'config/content';

import './PaginationSummary.scss';
import { simpleAmenityTextMap } from '../../../config/amenityMap';

const NMP_KEYWORD_LABEL = {
	'24-hour': '24 Hour Self Storage',
	'climate-controlled': 'Climate Controlled Self Storage',
	'drive-up': 'Drive Up Self Storage',
	electricity: 'Self Storage With Electricity',
	mini: 'Mini Self Storage',
	small: 'Small Self Storage',
	medium: 'Medium Self Storage',
	large: 'Large Self Storage',
	lockers: 'Self Storage Lockers',
	boat: 'Boat Self Storage',
	car: 'Car Self Storage',
	rv: 'RV Self Storage',
};

export function PaginationSummary({
	city,
	state,
	listingsPerPage,
	page,
	pageListingsCount,
	totalItems,
	amenityType,
	pageType,
	subPageType,
}) {
	const first = pageListingsCount ? (page - 1) * listingsPerPage + 1 : 0;
	const last = pageListingsCount ? first + pageListingsCount - 1 : 0;
	const isSpecialAmenity =
		amenityType === 'climate-controlled' ||
		amenityType === '24-hour-access' ||
		amenityType === 'drive-up-self-storage' ||
		amenityType === 'free-truck-rental';

	if (
		pageType === 'nearMeSearchPage' &&
		subPageType &&
		NMP_KEYWORD_LABEL[subPageType]
	) {
		return (
			<>{`Browse ${first} - ${last} of ${totalItems} ${NMP_KEYWORD_LABEL[subPageType]} Facilities Near You`}</>
		);
	}

	return (
		<>
			{city && state ? (
				<>{`${first} - ${last} of ${totalItems} Cheap ${simpleAmenityTextMap[amenityType] || 'Self'} Storage Facilities in ${city}, ${state}`}</>
			) : (
				<>
					<Text
						size="smallMedium"
						weight="standard"
						color="placeholderGray"
						last
					>
						{' '}
						•{' '}
					</Text>
					{`${first} - ${last} of ${totalItems} ${
						amenityObject[amenityType] || 'Self'
					} ${isSpecialAmenity ? 'Facilities' : 'Storage Facilities'}`}
				</>
			)}
		</>
	);
}

PaginationSummary.propTypes = {
	city: PropTypes.string,
	listingsPerPage: PropTypes.number,
	page: PropTypes.number,
	pageListingsCount: PropTypes.number,
	state: PropTypes.string,
	totalItems: PropTypes.number,
	amenityType: PropTypes.string,
	pageType: PropTypes.string,
	subPageType: PropTypes.string,
};

PaginationSummary.defaultProps = {
	totalItems: 0,
	pageListingsCount: 0,
};

export default PaginationSummary;
